import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';

export default class Warehouse extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            persons: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/warehouse/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    var persons = [];
                    data.record.persons.forEach(f => {
                        persons.push({
                            value: f.id,
                            label: f.name,
                        });
                    });

                    this.setState({
                        persons: persons,
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        var persons = [];
        this.state.persons.forEach(person => persons.push(person.value));

        if (this.isBlank(this.state.data.record.code)) this.state.data.record.code = 0;

        this.httpPost("api/v1/warehouse/save", {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            title: this.state.data.record.title,
            address: this.state.data.record.address,
            phone: this.state.data.record.phone,
            code: this.state.data.record.code,
            ioPermissionLevel: this.state.data.record.ioPermissionLevel,
            isDefault: this.state.data.record.isDefault,
            persons
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPerson(e) {
        this.state.persons = e;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات انبار" : "افزودن انبار جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">شماره تماس</label>
                                            <input defaultValue={this.state.data.record.phone} onChange={e => this.state.data.record.phone = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="20" />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">مجوز ثبت ورود/خروج</label>
                                            <select defaultValue={this.state.data.record.ioPermissionLevel} onChange={e => this.state.data.record.ioPermissionLevel = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="1">توسط هر کاربر</option>
                                                <option value="2">فقط توسط مسئولین</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <input defaultChecked={this.state.data.record.isDefault} onChange={e => this.state.data.record.isDefault = e.target.checked} type="checkbox" />
                                            انبار پیش فرض رسیدها و حواله ها (همیشه یک انبار به عنوان پیش فرض لحاظ میشود)
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">آدرس</label>
                                            <input defaultValue={this.state.data.record.address} onChange={e => this.state.data.record.address = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <label className="form-label">مسئولین</label>
                                        <SelectAsync
                                            defaultValue={this.state.persons}
                                            isMulti={true}
                                            placeholder="مسئولین"
                                            defaultOptions
                                            loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 3)}
                                            onChange={e => this.setPerson(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}